import { FC } from 'react'
import {
  BooleanField, Button, DateField, FunctionField, Show, SimpleShowLayout, TextField,
  useRecordContext, useRefresh, useNotify, useTranslate,
} from 'react-admin'
import { Chip } from '@mui/material'
import { SeverityChip } from '../../components'
import { postJson, getUrl } from '../../providers/data'
import { MonitoringAlertOut } from '../../types/apiRequests'

const AcknowledgeButton: FC = () => {
  const record = useRecordContext<MonitoringAlertOut>()
  const refresh = useRefresh()
  const notify = useNotify()
  const translate = useTranslate()

  if (!record) return null

  if (record.acknowledged) return <Chip label={translate('data.acknowledged')} color="success" size="small" />

  const handleAcknowledge = () => {
    void postJson(`${getUrl()}/monitoring_alert/${record.id}/acknowledge`)
      .then(() => { notify(translate('data.acknowledge'), { type: 'success' }); refresh() })
      .catch(() => notify('ra.notification.http_error', { type: 'error' }))
  }

  return <Button label="data.acknowledge" onClick={handleAcknowledge} />
}

const MonitoringAlertShow: FC = () => (
  <Show>
    <SimpleShowLayout>
      <FunctionField<MonitoringAlertOut>
        label="data.severity"
        render={(record) => <SeverityChip severity={record.severity} />}
      />
      <TextField source="message" />
      <TextField source="rule_display_name" label="resources.monitoring_rule.name" />
      <TextField source="organization_display_name" label="data.organization" />
      <BooleanField source="acknowledged" label="data.acknowledged" />
      <DateField source="created" showTime label="data.createdAt" />
      <AcknowledgeButton />
    </SimpleShowLayout>
  </Show>
)

export default MonitoringAlertShow
